<template>
  <div>
    <img
      v-if="source == 'credit_card'"
      src="https://cdn-icons-png.flaticon.com/512/6963/6963703.png" />
    <img
      v-if="source == 'bank'"
      src="https://cdn-icons-png.flaticon.com/512/5223/5223830.png" />
    <img
      v-if="source == 'mobilepay'"
      src="https://play-lh.googleusercontent.com/a5CpQQFBKcnvyr-Z5y6Cwp7Fk3NXR3ytv5IAM3_QXPYuIqf0Iguc8r41tBQDJ40eKTdg" />
    <img
      v-if="source == 'paypal'"
      src="https://cdn-icons-png.flaticon.com/512/174/174861.png" />
    <img
      v-if="source == 'applepay'"
      src="https://cdn-icons-png.flaticon.com/512/5968/5968601.png" />
    <img
      v-if="source.indexOf('klarna') >= 0"
      src="https://play-lh.googleusercontent.com/tDXSaAt_I_qx6am_rTcQ1WHaXo6ncfiB-b742DnSXZkJGASvs15yRYnvzogzbYwse0QD" />
    <img
      v-if="source == 'ideal'"
      src="https://cdn-icons-png.flaticon.com/512/196/196558.png" />
    <img
      v-if="source == 'sofort'"
      src="https://cdn.iconscout.com/icon/free/png-256/free-sofort-1-534029.png" />
    <img
      v-if="source == 'swish'"
      src="https://play-lh.googleusercontent.com/NiU9oukn_XtdpjyODVezYIxeZ3Obs04bH9VZa0MAhZN4s9x5mG9O1lO_ZF37CDKck_8K" />
    <img
      v-if="source == 'giropay'"
      src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Giropay.svg/2560px-Giropay.svg.png" />
  </div>
</template>

<script>
  export default {
    props: {
      source: {
        type: String,
        required: true,
      }
    }
  }
</script>

<style lang="less" scoped>
  img {
    width: 100%;
  }
</style>
